import React, { Component } from 'react';
import {
    deleteDocument,
    fetchDocument,
    saveDocument,
    setDocumentEditMode,
} from '../state/actions/DocumentActions';

import Can from '../Can';
import DeleteResourceButton from '../DeleteResource';
import { DocumentEditor } from './DocumentEditor';
import { DocumentViewer } from './DocumentViewer';
import { Error } from '../shared/Error/Error';
import { History } from '../../helpers';
import { LoadingIndicator } from '../shared/LoadingIndicator/LoadingIndicator';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

class DocumentDetails extends Component {
    constructor(props) {
        super(props);

        this.onSave = this.onSave.bind(this);
        this.onToggleEditMode = this.onToggleEditMode.bind(this);
        this.navBack = this.navBack.bind(this);
        this.onClose = this.onClose.bind(this);
    }

    componentDidMount() {
        const { documentId, fetchDocument } = this.props;

        if (documentId) {
            fetchDocument(documentId);
        }
    }

    onToggleEditMode() {
        const { isEditing, setDocumentEditMode } = this.props;

        setDocumentEditMode(!isEditing);
    }

    onSave(document) {
        const { saveDocument } = this.props;

        // TODO: find a better fix for null/empty values
        if (document.url.length === 0) {
            delete document['url'];
        }

        document.docType = 'UNSPECIFIED_TYPE';

        saveDocument(document)
            .then(() => {
                Swal({
                    title: 'Document record saved',
                    type: 'success',
                }).then(() => {
                    this.navBack();
                });
            })
            .catch(err => {
                Swal({
                    title: `Oops...`,
                    text: err,
                    type: 'error',
                }).then(() => {
                    this.navBack();
                });
            });
    }

    navBack() {
        const { isEditing, setDocumentEditMode, backLink } = this.props;

        if (isEditing) {
            setDocumentEditMode(false);
        } else {
            History.push(backLink || '/');
        }
    }

    onClose() {
        this.navBack();
    }

    render() {
        const { documentId, document, failed, fetched, fetching, isEditing } = this.props;

        if (!fetched && !failed) {
            return <LoadingIndicator busy={fetching} />;
        } else if (failed) {
            return <Error message="Failed to fetch document record" />;
        } else if (document) {
            let displayPrefix = 'Product';
            if (document && document.vendor) {
                displayPrefix = 'Vendor';
            }

            return (
                <div>
                    <div className="card mb-3">
                        <div className="card-body">
                            <Can I="delete" a="Document">
                                <div className="float-right">
                                    <DeleteResourceButton
                                        resourceId={documentId}
                                        deleteAction={this.props.deleteDocument}
                                        navBack={this.props.backLink}
                                    >
                                        Delete Document
                                    </DeleteResourceButton>
                                </div>
                            </Can>

                            <h4 className="card-title">
                                {document.name}{' '}
                                <small className="text-muted">{displayPrefix} Document</small>
                            </h4>

                            {isEditing ? (
                                <DocumentEditor
                                    document={document}
                                    save={this.onSave}
                                    close={this.onClose}
                                    onDelete={this.onDelete}
                                />
                            ) : (
                                <DocumentViewer
                                    document={document}
                                    toggleEditMode={this.onToggleEditMode}
                                    close={this.onClose}
                                    onDelete={this.onDelete}
                                />
                            )}
                        </div>
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }
}

DocumentDetails.propTypes = {
    deleteDocument: PropTypes.func.isRequired,
    fetchDocument: PropTypes.func.isRequired,
    saveDocument: PropTypes.func.isRequired,
    setDocumentEditMode: PropTypes.func.isRequired,
    fetched: PropTypes.bool.isRequired,
    fetching: PropTypes.bool.isRequired,
    isEditing: PropTypes.bool.isRequired,
    documentId: PropTypes.string.isRequired,
    failed: PropTypes.bool,
    document: PropTypes.object,
    backLink: PropTypes.string,
};

// CONFIGURE REACT REDUX
const mapStateToProps = state => {
    const { fetching, fetched, failed, document, documentUrl, isEditing } = state.document;

    return { fetching, fetched, failed, document, documentUrl, isEditing };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchDocument,
            saveDocument,
            setDocumentEditMode,
            deleteDocument,
        },
        dispatch
    );

const hoc = connect(mapStateToProps, mapDispatchToProps)(DocumentDetails);

// EXPORT COMPONENT
export { hoc as DocumentDetails };
